export const SIGNUP_REQUEST = 'SIGNUP_REQUEST';
export const SIGNUP_SUCCESS = 'SIGNUP_SUCCESS';
export const SIGNUP_FAILURE = 'SIGNUP_FAILURE';

export const GET_SIGNUP_DATA_REQUEST = 'GET_SIGNUP_DATA_REQUEST';
export const GET_SIGNUP_DATA_SUCCESS = 'GET_SIGNUP_DATA_SUCCESS';
